import { AxiosRequestConfig } from 'axios';
import { CommonHeaders } from '../shared/util/common-headers';

const LoginApiWrapper = (requests: any) => {
	return {
		loginUser: (body: any) => {
			const config: AxiosRequestConfig = {
				headers: CommonHeaders.LOGIN_HEADERS,
			};
			return requests.post(`/customer/session/login`, body, config);
		},

		activateAccount: (body: any) => {
			const config: AxiosRequestConfig = {
				headers: CommonHeaders.LOGIN_HEADERS,
			};
			return requests.post(`/customer/account/activate-temporary-account`, body, config);
		},

		verificationStatus: () => {
			const config: AxiosRequestConfig = {
				headers: CommonHeaders.LOGIN_HEADERS,
			};
			return requests.get(`/customer/account/verification-status`, config);
		},
		keepAlive: (isLoggedIn: boolean) => {
			const config: AxiosRequestConfig = {
				headers: CommonHeaders.LOGIN_HEADERS,
			};
			return requests.get(`/customer/session/keep-alive?keepAlive=${isLoggedIn}`, config);
		},
		logOutUser: () => {
			const config: AxiosRequestConfig = {
				headers: CommonHeaders.LOGIN_HEADERS,
			};
			return requests.delete(`/customer/session/logout`, config);
		},
	};
};

export default LoginApiWrapper;
